import { SimpleShowLayout, TextField } from 'react-admin'
import { useRecordContext } from "react-admin";
import { Box } from "@mui/material";

const JsonField = ({ source }: { source: string }) => {
  const record = useRecordContext();
  if (!record) return null;

  const value = record[source];

  let formattedValue = value;

  try {
    if (typeof value === "string") {
      const parsed = JSON.parse(value);
      formattedValue = JSON.stringify(parsed, null, 2);
    }
    else if (typeof value === "object") {
      formattedValue = JSON.stringify(value, null, 2);
    }
  } catch (e) {
    formattedValue = value;
  }

  return (
    <Box
      component="pre"
      sx={{
        backgroundColor: "#f5f5f5",
        padding: 2,
        borderRadius: 1,
        fontSize: 14,
        overflowX: "auto",
      }}
    >
      {formattedValue}
    </Box>
  );
};


function AppConstantMetaShow() {
    return (
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="name" />
            <JsonField source="value" />
        </SimpleShowLayout>
    )
}

export default AppConstantMetaShow
